import styled from "styled-components";

export const DadosUsuario: React.FC = styled.div`
  ::before {
    content: "";
    position: absolute;
    top: 0%;
    height: 100%;
    width: 1px;
    background-color: var(--grey-200);
  }

  p div {
    width: 70px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const MenuNav: React.FC = styled.nav`
  font-family: "Source Sans Pro", sans-serif;

  ul li {
    list-style: none;
    display: inline-block;
    margin-right: 15px;
    cursor: pointer;
  }

  ul li a {
    font-size: 14px;
    color: var(--grey-700);
  }

  ul li a:hover {
    color: var(--primary-mid-light);
  }
`;

export const MenuNavXS: React.FC = styled.nav`
  font-family: "Source Sans Pro", sans-serif;

  ul li {
    list-style: none;
    margin-bottom: 15px;
    cursor: pointer;
  }

  ul li a {
    font-size: 16px;
    font-weight: 600;
    color: var(--grey-900);
  }

  ul li a:hover {
    color: var(--primary-mid-light);
  }
`;

export const ContainerMenu = styled.div`
  img.imagem-logo {
    margin-bottom: 40px;
  }
`;

export const FooterMenu = styled.div`
  padding: 20px;
  cursor: pointer;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ItemMenu = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

